
import React from "react";
import { useNavigate } from "react-router-dom";

const Navbar = ({ toggleSidebar }) => {
  const navigate = useNavigate();
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));

  const firstName = userDetails?.personalInformation?.firstName || "";
  const lastName = userDetails?.personalInformation?.lastName || "";
  const nameInitials = userDetails?.personalInformation?.nameInitials || "UN";
  const companyName = userDetails?.companyInformation?.companyName || "N/A";

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userDetails");
    navigate("/");
  };

  return (
    <div className="bg-white px-3 md:px-4 py-3 flex justify-between items-center shadow">
      {/* Left: hamburger + logo */}
      <div className="flex items-center gap-3">
        <img
          src="../dashboard-icon.svg"
          alt="Toggle sidebar"
          onClick={toggleSidebar}
          className="cursor-pointer w-6 h-6 flex-shrink-0"
        />
        <img src="../jbm-logo.svg" alt="JBM Logo" className="w-20 md:w-24" />
      </div>

      {/* Right: user info + logout */}
      <div className="flex items-center gap-3 md:gap-6">
        {/* Avatar — always visible */}
        <div className="flex items-center gap-2">
          <p className="p-2 bg-lightPrimary rounded-full text-sm font-medium flex-shrink-0">
            {nameInitials}
          </p>

          {/* Name + plant — hidden on mobile */}
          <div className="hidden md:block">
            <p className="text-sm leading-tight">
              {firstName} {lastName}
            </p>
            <p className="text-xs text-gray-500 leading-tight">
              Plant: {companyName}
            </p>
          </div>
        </div>

        {/* Logout — full button on md+, icon-only on mobile */}
        <button
          onClick={handleLogout}
          className="logout-btn flex items-center gap-2 bg-primary text-white font-semibold rounded-lg
                     px-3 py-1.5 md:px-6 md:text-base text-sm"
          aria-label="Logout"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2.5}
            stroke="currentColor"
            className="w-5 h-5 flex-shrink-0"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75"
            />
          </svg>
          {/* Text hidden on mobile */}
          <span className="hidden md:inline">Logout</span>
        </button>
      </div>
    </div>
  );
};

export default Navbar;